import React from "react";
import "./Header.scss";
import {
  AppRoute,
  implementationExamples,
  pluginsLinks,
  technicalSolutionsLinks,
} from "../../../constants";
import {
  Dropdown, NavDropdown, Nav,
  Navbar
} from "react-bootstrap";
import { Logo } from "./Logo";
import { ToggleSwitch } from "../switch/ToggleSwitch";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const getActiveLinkClass = (link, pathname) => {

  return link.split('/').join('') == pathname.split('/').join('') ? 'active-link' : ''
}
const DropdownMenuRenderer = ({ items }) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const renderItems = (items, root = true) => {
    const uncategorized = [];
    const categorized = [];
    const rendered = [];
    items.forEach((item) => {
      if (typeof item.list != "undefined") {
        categorized.push(item);
      } else {
        uncategorized.push(item);
      }
    });
    if (categorized.length) {
      rendered.push(
        ...categorized.map((item, idx) => (
          <div>
            {item.title && (
              <NavDropdown.Header className="text-info">
                <h6>{item.title}</h6>
              </NavDropdown.Header>
            )}
            {renderItems(item.list, false)}
            {item.title && idx < categorized.length - 1 && (
              <hr className="mx-2" />
            )}
          </div>
        ))
      );
    }

    if (uncategorized.length) {
      rendered.push(<div>
        {uncategorized.map((i) => (
          <NavDropdown.Item href={`/${i.link}`} key={i.title} className={getActiveLinkClass(`/${i.link}`, pathname)}>
            {i.title} {i.isExpertPlus && <span style={{ fontSize: '10px' }} className="ml-1 badge-danger">Expert +</span>}
          </NavDropdown.Item>
        ))}
      </div>)
    }
    return rendered;
  };
  return <div className="d-flex">{renderItems(items)}</div>;
};

function Header() {
  const { pathname } = useLocation()

  const navigate = useNavigate()


  return (
    <header className="header page-header px-4">
      <Navbar
        collapseOnSelect
        expand="lg"
        className="bg-body-black header__container"
      // data-bs-theme="dark"
      >

        <Navbar.Brand
          href={AppRoute.MainPage}
          style={{ margin: "0 40px 0 0", padding: 0, width: '100px' }}
        >
          <Logo />
        </Navbar.Brand>

        <Navbar.Toggle className="toggler" aria-controls="responsive-navbar-nav" />




        <Navbar.Collapse id="responsive-navbar-nav" className="nav">
          <Nav className="me-auto nav-item_color">
            <Dropdown style={{
              "--bs-nav-link-color": "RGBA(255,255,255,0.75)",
              fontSize: "14px",
            }} as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Item} className="dropdown-toggle nav-link" role="button">
                Компоненты системы
              </Dropdown.Toggle>
              <Dropdown.Menu renderOnMount>
                <DropdownMenuRenderer items={pluginsLinks} />
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown style={{
              "--bs-nav-link-color": "RGBA(255,255,255,0.75)",
              fontSize: "14px",
            }} as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Item} className="dropdown-toggle nav-link" role="button">
                Примеры внедрения
              </Dropdown.Toggle>
              <Dropdown.Menu renderOnMount>
                {implementationExamples.map((i) => (
                  <NavDropdown.Item
                    href={`${i.link}`}
                    key={i.title}
                    className={`nav-item ${getActiveLinkClass(`/${i.link}`, pathname)}`}
                  >
                    {i.title} {i.isExpertPlus && <span style={{ fontSize: '10px' }} className="ml-1 badge-danger">Expert +</span>}

                  </NavDropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <Nav.Link
              href={AppRoute.News}
              className={pathname.includes('news') ? 'active-link' : ''}
              style={{
                "--bs-nav-link-color": "RGBA(255,255,255,0.75)",
                fontSize: "14px",
              }}
            >
              Новости
            </Nav.Link>
          </Nav>

        </Navbar.Collapse>
      </Navbar>
    </header>
  );
}

export default Header;
